import {
    Component,
    computed,
    effect,
    ElementRef,
    inject,
    input,
    InputSignal,
    Signal,
    viewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectQuery, emptyProjectQuery } from '@dat/datiq-nx-repo-utils';
import { IqStatusLibraryStateService } from '../state';

@Component({
    selector: 'iq-status-library-visualization',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-status-library-visualization.component.html',
    styleUrl: './iq-status-library-visualization.component.scss',
})
export class IqStatusLibraryVisualizationComponent {
    private _state: IqStatusLibraryStateService = inject(
        IqStatusLibraryStateService,
    );
    id: InputSignal<string> = input<string>();
    testId: InputSignal<string> = input<string>();

    query: InputSignal<ProjectQuery> = input<ProjectQuery>({
        ...emptyProjectQuery,
    });

    depEl = viewChild<ElementRef>('deps');
    envEl = viewChild<ElementRef>('env');
    teamEl = viewChild<ElementRef>('team');
    libraryEl = viewChild<ElementRef>('libraryTypes');
    domainEl = viewChild<ElementRef>('domains');

    numOfProjects: number = 0;

    currentTestId: Signal<string> = computed(() => {
        return this.testId()?.length ? this.testId() : this.id();
    });

    constructor() {
        effect(async () => {
            const query: ProjectQuery = this.query();

            this.numOfProjects = await this._state.numOfProjects(query);
            this._state.updateDepViz(this.depEl()?.nativeElement, query);
            this._state.updateEnvViz(this.envEl()?.nativeElement, query);
            this._state.updateTeamViz(this.teamEl()?.nativeElement, query);
            this._state.updateDomainViz(this.domainEl()?.nativeElement, query);
            this._state.updateLibraryViz(
                this.libraryEl()?.nativeElement,
                query,
            );
        });
    }
}
